import * as yup from 'yup';

export const schemaSendSms = yup
  .object()
  .shape({
    phone: yup.string().required('Обязательное поле').min(18, 'Поле не заполнено'),
  })
  .required();

export const schemaSendCode = yup
  .object()
  .shape({
    code: yup.string().required('Обязательное поле').min(4, 'Поле не заполнено'),
  })
  .required();

export const schemaEmail = yup
  .object()
  .shape({
    email: yup.string().email('Некорректный email').required('Обязательное поле'),
  })
  .required();

export const schemaPhoneConfirmation = (limit: number) =>
  yup
    .object()
    .shape({
      code: yup.string().required('Обязательное поле').min(limit, 'Поле не заполнено'),
    })
    .required();

export const schemaPayOnClick = yup
  .object()
  .shape({
    fio: yup.string().required('Обязательное поле').max(100, 'Максимальное кол-во символов превышено').trim(),
    phone: yup.string().required('Обязательное поле').min(18, 'Поле не заполнено'),
    email: yup.string().email('Некорректный email').required('Обязательное поле').max(100, 'Максимальное кол-во символов превышено'),
    comment: yup.string().max(150, 'Максимальное кол-во символов превышено'),
    agree: yup.boolean().isTrue().required(),
  })
  .required();

export const schemaDeliveryForm = yup
  .object()
  .shape({
    address: yup.string().required('Обязательное поле'),
    comment: yup.string().max(150, 'Максимальное кол-во символов превышено'),
  })
  .required();

export const schemaFormOrder = yup
  .object()
  .shape({
    firstName: yup.string().required('Обязательное поле').max(100, 'Максимальное кол-во символов превышено').trim(),
    lastName: yup.string().required('Обязательное поле').max(100, 'Максимальное кол-во символов превышено').trim(),
    phone: yup.string().required('Обязательное поле').min(18, 'Поле не заполнено'),
    email: yup.string().email('Исправьте адрес эл. почты').required('Обязательное поле').max(100, 'Максимальное кол-во символов превышено'),
    comment: yup.string().max(150, 'Максимальное кол-во символов превышено'),
  })
  .required();

export const schemaFullFormOrder = schemaFormOrder
  .shape(
    {
      inn: yup.string().when('inn', val => {
        if (val?.length === 11) {
          return yup
            .string()
            .required('Обязательное поле')
            .min(12, 'Пожалуйста, убедитесь, что поле содержит ровно 10 или 12 цифр.')
            .max(12, 'Пожалуйста, убедитесь, что поле содержит ровно 10 или 12 цифр.')
            .trim();
        } else {
          return yup
            .string()
            .required('Обязательное поле')
            .min(10, 'Пожалуйста, убедитесь, что поле содержит ровно 10 или 12 цифр.')
            .max(12, 'Пожалуйста, убедитесь, что поле содержит ровно 10 или 12 цифр.')
            .trim();
        }
      }),
      kpp: yup
        .string()
        .trim()
        .when('inn', {
          is: schema => schema.length === 12,
          then: schema => schema.notRequired(),
          otherwise: schema =>
            schema.required('Обязательное поле').min(9, 'Минимальное кол-во символов 9').max(9, 'Максимальное кол-во символов превышено'),
        }),
      nameOrganization: yup
        .string()
        .required('Обязательное поле')
        .min(3, 'Минимальное кол-во символов 3')
        .max(100, 'Максимальное кол-во символов превышено')
        .trim(),
      addressOrganization: yup.string().max(250, 'Максимальное кол-во символов превышено'),
      bik: yup.string().max(100, 'Максимальное кол-во символов превышено'),
      checkingAccount: yup.string().max(100, 'Максимальное кол-во символов превышено'),
    },
    ['inn', 'inn'],
  )
  .required();

export const schemaFormRecordPhone = yup
  .object()
  .shape({
    name: yup.string().required('Обязательное поле'),
    phone: yup.string().required('Обязательное поле'),
  })
  .required();

export const schemaFormSubScr = yup
  .object()
  .shape({
    email: yup.string().email('Неправильно введен E-mail').required('Вы не указали E-mail'),
  })
  .required();

export const schemaCorporateForm = yup
  .object()
  .shape({
    firstName: yup.string().required('Обязательное поле'),
    phone: yup.string().required('Обязательное поле').min(18, 'Поле не заполнено'),
    email: yup.string().email('Некорректный email').required('Обязательное поле'),
    nameOrganization: yup.string().required('Обязательное поле'),
    comment: yup.string().max(150, 'Максимальное кол-во символов превышено'),
  })
  .required();

export const schemaFormPickUpStore = yup
  .object({
    shopName: yup.string().required('Обязательное поле'),
    fio: yup.string().required('Обязательное поле'),
    email: yup.string().email('Неправильно введен E-mail'),
    phone: yup.string().required('Обязательное поле').min(18, 'Поле не заполнено'),
    comment: yup.string(),
    agree: yup.boolean().isTrue().required(),
  })
  .required();

export const schemaFormFastOrder = yup
  .object({
    shopId: yup.number().required('Обязательное поле'),
    fio: yup.string().required('Обязательное поле'),
    email: yup.string().email('Неправильно введен E-mail'),
    phone: yup.string().required('Обязательное поле').min(18, 'Поле не заполнено'),
    comment: yup.string(),
    agree: yup.boolean().isTrue().required(),
  })
  .required();

export const schemaCommentForm = (rating: number) => {
  const yupPhone = yup.string(); 

  return yup.object().shape({
    name: yup.string().required('Обязательное поле'),
    email: yup.string()
      .email('Неправильно введен E-mail'),
    phone: yupPhone,
    message: yup.string()
      .required('Обязательное поле')  
      .max(2048, 'Превышена максимальная длина'),
  }).required();
};

export const schemaFormLogin = yup
  .object()
  .shape({
    email: yup.string().email('Неправильно введен E-mail').required('Вы не указали E-mail'),
    password: yup.string().required('Вы не указали Пароль'),
  })
  .required();

export const schemaFormRegistration = yup
  .object()
  .shape({
    firstName: yup.string().required('Вы не указали Имя').min(4, 'Минимальное число символов 4'),
    lastName: yup.string().required('Вы не указали Фамилию').min(4, 'Минимальное число символов 4'),
    email: yup
      .string()
      .email('Неправильно введен E-mail')
      .required('Вы не указали E-mail')
      .matches(
        /^[a-zA-Z0-9@_.-]+$/,
        'Введено некорректное имя ящика. Допустимо использовать только латинские буквы, цифры, знак подчеркивания, точку и минус.',
      ),
    phone: yup
      .string()
      .required('Обязательное поле')
      .min(18, 'Поле не заполнено')
      .matches(/^[0-9-+()\s]+$/, 'Введено некорректный телефон'),
    password: yup
      .string()
      .required('Вы не указали Пароль')
      .min(6, 'Минимальная длина пароля 6 символов')
      .max(20, 'Максимальная длина пароля 20 символов')
      .matches(
        // eslint-disable-next-line no-useless-escape
        /^[a-zA-Z0-9!"#$%&'()*+,\-.\/:;<=>?@\[\\\]^_{|}~]+$/,
        'Пароль некорректный',
      ),
    passwordConfirmation: yup
      .string()
      .label('confirm password')
      .required('Повторите пароль')
      .oneOf([yup.ref('password'), null], 'Пароли не совпадают'),
    agree: yup.boolean().isTrue().required(),
  })
  .required();

export const schemaFormForgotPassword = yup
  .object()
  .shape({
    email: yup.string().email('Неправильно введен E-mail').required('Вы не указали E-mail'),
  })
  .required();

export const schemaFormProfileUser = yup
  .object()
  .shape({
    firstName: yup
      .string()
      .required('Вы не указали Имя')
      .matches(/^[А-Яа-яЁёs-]+$/, 'Введите имя по-русски')
      .min(2, 'Минимальное число символов 2')
      .max(40, 'Превышена максимальная длина'),
    surName: yup
      .string()
      .notRequired()
      .test('sur_name', 'Фамилия должна содержать минимум 2 символа и состоять только из русских букв', function (value) {
        if (value) {
          const schema = yup
            .string()
            .required('Вы не указали Фамилию')
            .matches(/^[А-Яа-яЁёs-]+$/, 'Введите фамилию по-русски')
            .min(2, 'Минимальное число символов 2')
            .max(40, 'Превышена максимальная длина');
          return schema.isValidSync(value);
        }
        return true;
      }),
    lastName: yup
      .string()
      .notRequired()
      .test('last_name', 'Отчество должно содержать минимум 2 символа и состоять только из русских букв', function (value) {
        if (value) {
          const schema = yup
            .string()
            .required('Вы не указали Отчество')
            .matches(/^[А-Яа-яЁёs-]+$/, 'Введите отчество по-русски')
            .min(2, 'Минимальное число символов 2')
            .max(40, 'Превышена максимальная длина');
          return schema.isValidSync(value);
        }
        return true;
      }),
    email: yup
      .string()
      .notRequired()
      .test('email', 'Неправильный E-mail', function (value) {
        if (value) {
          return yup.string().email('Неправильно введен E-mail').isValidSync(value);
        }
        return true;
      }),
    phone: yup.string().required('Обязательное поле').min(18, 'Поле должно содержать минимум 18 символов'),
  })
  .required();

export const schemaFormAddDiscountCard = yup
  .object()
  .shape({
    numDiscountCard: yup.string().required('Обязательное поле'),
    phone: yup.string().required('Обязательное поле').min(18, 'Поле не заполнено'),
  })
  .required();

export const schemaFormChangePassword = yup
  .object()
  .shape({
    password: yup
      .string()
      .required('Вы не указали Пароль')
      .min(6, 'Минимальная длина пароля 6 символов')
      .max(20, 'Максимальная длина пароля 20 символов')
      .matches(
        // eslint-disable-next-line no-useless-escape
        /^[a-zA-Z0-9!"#$%&'()*+,\-.\/:;<=>?@\[\\\]^_{|}~]+$/,
        'Пароль некорректный',
      ),
    passwordConfirmation: yup
      .string()
      .label('confirm password')
      .required('Повторите пароль')
      .oneOf([yup.ref('password'), null], 'Пароли не совпадают'),
  })
  .required();

export const schemaFormActivateWarranty = yup
  .object()
  .shape({
    code: yup.string().required('Вы не указали код'),
    name: yup.string().required('Вы не указали Имя'),
    lastName: yup.string().required('Вы не указали Фамилию'),
    phone: yup.string().required('Обязательное поле').min(18, 'Поле не заполнено'),
    email: yup.string().email('Неправильно введен E-mail').required('Вы не указали E-mail'),
    registrationNumber: yup.string().required('Обязательное поле'),
    mark: yup.string().required('Обязательное поле'),
    model: yup.string().required('Обязательное поле'),
    year: yup.string().required('Обязательное поле'),
    agree: yup.boolean().isTrue().required(),
  })
  .required();

export const schemaFormAddCart = yup
  .object()
  .shape({
    mark: yup.string().required('Вы не указали марку авто'),
    model: yup.string().required('Вы не указали модель авто'),
    gosNum: yup.string().required('Вы не указали Гос.номер'),
  })
  .required();

export const schemaFormFeedBackLk = yup
  .object()
  .shape({
    message: yup.string().required('Обязательное поле').max(300, 'Максимальное кол-во символов превышено'),
  })
  .required();

export const schemaFormFeedbackAuto = yup
  .object()
  .shape({
    message: yup.string().when('linkSite', (val: string) => {
      if (!val?.length) {
        return yup.string().required('Обязательное поле').max(300, 'Максимальное кол-во символов превышено');
      } else {
        return yup.string().max(300, 'Максимальное кол-во символов превышено');
      }
    }),
    linkSite: yup.string(),
  })
  .required();

export const schemaFormOrderCancelComment = yup
  .object()
  .shape({
    desc: yup.string().max(240, 'Максимальное кол-во символов превышено'),
  })
  .required();

export const schemaJobApplicationForm = yup
  .object()
  .shape({
    name: yup.string().required('Вы не указали Имя').min(2, 'Минимальная длина 2 символа'),
    phone: yup.string().required('Обязательное поле').min(18, 'Поле не заполнено'),
  })
  .required();

export const schemaRequestForm = schemaJobApplicationForm
  .concat(
    yup.object().shape({
      message: yup.string().required('Обязательное поле').min(2, 'Минимальная длина 2 символа').max(300, 'Максимальная длина 300 символов'),
    }),
  )
  .required();

export const schemaFormSupportRequest = yup
  .object()
  .shape({
    templateMessage: yup.string().required('Обязательное поле'),
    name: yup.string(),
    email: yup.string().email('Неправильно введен E-mail'),
    phone: yup.string().required('Обязательное поле').min(18, 'Поле не заполнено'),
    message: yup.string().required('Обязательное поле').max(300, 'Максимальное кол-во символов превышено'),
    agree: yup.boolean().isTrue().required(),
  })
  .required();
